import { useMemo } from "react";
import { noteColorsOf } from "./utils";
import type { MarkerNoteFrameProps } from "./types";

export const MarkerNoteFrame = ({
  rgb,
  header,
  children,
}: MarkerNoteFrameProps) => {
  const colors = useMemo(() => noteColorsOf(rgb), [rgb]);

  return (
    <div
      className="relative rounded-xl p-1"
      style={{
        backgroundColor: colors.frame,
        boxShadow: `0 8px 22px ${colors.glow}`,
      }}
    >
      <div
        className="flex flex-wrap items-baseline gap-x-1.5 px-2.5 pb-1.5 pt-1 text-xs"
        style={{ color: colors.ink }}
      >
        {header}
      </div>
      {children}
      <div
        className="absolute -bottom-1 left-4 h-2.5 w-2.5 rotate-45"
        style={{ backgroundColor: colors.frame }}
      />
    </div>
  );
};
